import { rgba, darken, lighten } from 'polished';

export const WHITE = '#FFFFFF';
export const BLACK = '#000000';
export const TRANSPARENT = 'transparent';

// Primary
export const SHAMROCK = '#2F9F59';
export const MAIN_BLACK = '#2A2A35';
export const RADICAL_RED = '#FF2C4A';
export const BITTERSWEET = '#FF625F';
export const DANDELION = '#FCD55D';
export const KOURNIKOVA = '#FFDD75';
export const SANTAS_GRAY = '#9A9AAA';
export const SANTAS_GRAY_2 = '#9F9FAE';
export const GRAY_SUIT = '#BFBFD1';
export const ATHENS_GRAY = '#F0F0F3';
export const ROYAL_BLUE_2 = '#5759EA';

export const BRIGHT = ATHENS_GRAY;
export const YELLOW = DANDELION;
export const LIGHTGREY = GRAY_SUIT;
export const DARKGREY = SANTAS_GRAY;
export const PURPLE = ROYAL_BLUE_2;

// Secondary
export const AQUA_FOREST = '#63AE7D';
export const AQUA_HAZE = '#EDF2F5';
export const AQUA_HAZE_2 = '#EEF2F5';
export const PORCELAIN = '#F5F6F7';
export const PORCELAIN_2 = '#E6E9EB';
export const MYSTIC = '#E3E9F0';
export const MISCHKA = '#DFDFE8';
export const CHATHAMS_BLUE = '#124076';
export const AZURE_RADIANCE = '#0096FF';
export const WOODSMOKE = '#131415';
export const WOODSMOKE_2 = '#0F1011';
export const SHARK = '#202223';
export const ALTO = '#d8d8d8';
export const ROLLING_STONE = '#747576';
export const EDWARD = '#A0A1A1';
export const CATSKILL_WHITE = '#F4F6FA';
export const WATERLOO = '#858691';
export const BURNT_SIENNA = '#EE5962';
export const ROYAL_BLUE = '#4E4BEE';
export const VIOLET = '#080836';
export const ALABASTER = '#FBFBFB';

// SNACKBAR
const snackbar = {
  snackbar: {
    bg: MAIN_BLACK,
    text: WHITE,
    btn: rgba(WHITE, 0.8),
    shadow: rgba(MAIN_BLACK, 0.15),
  },
};

// PAPER
const paper = {
  paper: {
    boxShadow: rgba(BLACK, 0.6),
    elevation4: AQUA_HAZE,
    elevation5: rgba(BLACK, 0.06),
    elevation9: rgba(CHATHAMS_BLUE, 0.07),
  },
};

// BUTTONS
const buttons = {
  buttons: {
    danger: {
      contained: {
        bg: BITTERSWEET,
        text: WHITE,
        bgHover: darken(0.05, BITTERSWEET),
      },
      outlined: {
        bg: WHITE,
        text: BITTERSWEET,
        bgHover: lighten(0.28, BITTERSWEET),
        border: BITTERSWEET,
      },
    },
    default: {
      bg: WHITE,
      color: MAIN_BLACK,
      bgHover: MYSTIC,
      outlined: {
        bg: WHITE,
        color: MAIN_BLACK,
        border: MYSTIC,
      },
    },
  },
};

// INPUTS
const inputs = {
  inputs: {
    border: MYSTIC,
    defaultIcon: MISCHKA,
    background: WHITE,
  },
};

// CHECKBOX
const checkbox = {
  checkbox: {
    border: SHAMROCK,
    color: WHITE,
  },
};

// RATING
const rating = {
  rating: {
    default: BRIGHT,
    active: YELLOW,
    large: {
      color: BRIGHT,
      bg: TRANSPARENT,
      activeColor: WHITE,
      activeBg: YELLOW,
      shadow: rgba(CHATHAMS_BLUE, 0.07),
      border: MYSTIC,
    },
  },
};

// SKELETON
const skeleton = {
  skeleton: {
    bg: BRIGHT,
  },
};

// TOOLTIP
const tooltip = {
  tooltip: {
    bg: WOODSMOKE,
    text: WHITE,
  },
};

// LIST ITEM
const listItem = {
  listItem: {
    bg: BRIGHT,
  },
};

// RadioCard
const radioCard = {
  radioCard: {
    border: MYSTIC,
    shadow: rgba(CHATHAMS_BLUE, 0.07),
    check: WHITE,
  },
};

// CheckboxCard
const checkboxCard = {
  checkboxCard: {
    border: MYSTIC,
    shadow: rgba(CHATHAMS_BLUE, 0.07),
    check: WHITE,
    checkedHover: {
      border: RADICAL_RED,
      iconBg: RADICAL_RED,
    },
  },
};

// AppCard
const appCard = {
  appCard: {
    bg: WHITE,
    cost: SANTAS_GRAY,
    hover: {
      shadow: rgba(BLACK, 0.06),
    },
  },
};

// Season Card
const seasonCard = {
  seasonCard: {
    bg: WHITE,
    cost: SANTAS_GRAY,
    years: SANTAS_GRAY,
    hover: {
      shadow: rgba(BLACK, 0.06),
    },
  },
};

// Header
const header = {
  header: {
    inactive: {
      bg: TRANSPARENT,
      text: WHITE,
    },
    active: {
      bg: WHITE,
      text: MAIN_BLACK,
    },
    counter: {
      color: WHITE,
    },
  },
};

// Footer
const footer = {
  footer: {
    menu: {
      title: WHITE,
      link: EDWARD,
    },
    termsPolicy: {
      bg: WOODSMOKE_2,
      color: ROLLING_STONE,
      link: WHITE,
    },
  },
};

// Breadcrumbs
const breadcrumbs = {
  breadcrumbs: {
    link: GRAY_SUIT,
  },
};

// Table
const table = {
  table: {
    cellBorder: rgba(PORCELAIN_2, 0.4),
    headBorder: rgba(PORCELAIN_2, 0.4),
    pagination: SANTAS_GRAY,
  },
};

// Tabs
const tabs = {
  tabs: {
    text: MAIN_BLACK,
    bg: AQUA_HAZE_2,
    activeText: WHITE,
  },
};

// ChannelCard
const channelCard = {
  channelCard: {
    hover: {
      shadow: rgba(BLACK, 0.06),
    },
  },
};

// LinearProgress
const linearProgress = {
  linearProgress: {
    bg: ATHENS_GRAY,
    barBg: DANDELION,
  },
};

// Service Card
const serviceCard = {
  serviceCard: {
    bg: WHITE,
    hover: {
      shadow: rgba(BLACK, 0.06),
    },
  },
};

// Chip
const chip = {
  chip: {
    text: WHITE,
    bg: MAIN_BLACK,
    hoverBg: SHAMROCK,
  },
};

export default {
  ...snackbar,
  ...paper,
  ...buttons,
  ...inputs,
  ...checkbox,
  ...rating,
  ...skeleton,
  ...tooltip,
  ...listItem,
  ...radioCard,
  ...checkboxCard,
  ...appCard,
  ...seasonCard,
  ...header,
  ...footer,
  ...breadcrumbs,
  ...table,
  ...tabs,
  ...channelCard,
  ...linearProgress,
  ...serviceCard,
  ...chip,

  bg: PORCELAIN,
  title: MAIN_BLACK,
  text: MAIN_BLACK,
  textSecondary: SANTAS_GRAY,
  link: BITTERSWEET,
  divider: PORCELAIN_2,
  success: SHAMROCK,
  error: BITTERSWEET,
  warning: KOURNIKOVA,
  primary: SHAMROCK,
  primaryText: WHITE,
  secondary: MAIN_BLACK,
};
